export default "__VITE_ASSET__7db878c9__"